export function getErrorMessage(error: unknown): string {
  if (error instanceof Error) {
    if ('status' in error && (error as { status: number }).status === 429) {
      return 'Zu viele Anfragen. Bitte warte einen Moment.';
    }
    return error.message;
  }
  return 'Ein unbekannter Fehler ist aufgetreten';
}
